import Vue from 'vue';
import VAutoNumeric from "../components/base/VAutoNumeric";

Vue.component("v-auto-numeric", VAutoNumeric);